
( function ( $, event_list_data ) {
	"use strict";

	var $results_wrapper,
		$result_template;

	/**
	 * Callback for the Ajax Load More response, displays all the search results.
	 *
	 * @param array posts The event posts returned via ajax.
	 */
	function jdrf_display_search_results( posts ) {
		for ( var i = 0; i < posts.length; i++ ) {
			display_search_result( posts[ i ] );
		}
	}

	/**
	 * Displays a single search result, using templates.
	 *
	 * @param array post A single search result to display.
	 */
	function display_search_result( post ) {
		var $new_wrapper = $result_template.clone(),
			$title_el,
			$post_type_el,
			$meta_el,
			img_size,
			$img_el,
			text_node      = null,
			$read_more     = null,
			excerpt_text,
			$excerpt;

		$new_wrapper.removeClass( 'jdrf-template js-search-result-template' );

		$title_el = $new_wrapper.find( 'h3 a' );

		$title_el.attr( 'href', post['permalink'] );

		$post_type_el = $new_wrapper.find( 'h3 span' );

		if ( post['post_type_name'] ) {
			$post_type_el.text( post['post_type_name'] );
		} else {
			$post_type_el.remove();
		}

		$meta_el = $new_wrapper.find( '.js-media-meta' );

		if ( post['post_date'] ) {
			$meta_el.children( '.js-media-meta-date' ).text( post['post_date'] );
		} else {
			$meta_el.children( '.js-media-meta-date' ).remove();
		}

		if ( post['site_name'] ) {
			$meta_el.children( '.js-media-meta-blog' ).text( post['site_name'] );
		} else {
			$meta_el.children( '.js-media-meta-blog' ).remove();
		}

		if ( 0 >= $meta_el.children().size() ) {
			$meta_el.remove();
		}

		if ( post['external_result'] ) {
			$title_el.attr( 'target', '_blank' );
		}

		$title_el.text( decode_entities( post['post_title'] ) );

		if ( post['image_sizes'] && post['image_sizes']['search-thumbnail'] && post['image_dir'] ) {
			img_size = post['image_sizes']['search-thumbnail'];
			$img_el  = $( '<img>', {
				'src'    : post['image_dir'] + img_size['file'],
				'width'  : img_size['width'],
				'height' : img_size['height'],
				'class'  : 'after'
			} );

			$new_wrapper.prepend( $img_el );
		}

		if ( post['excerpt'] ) {
			$excerpt = $( '<p>' );
			$excerpt.html( '' );

			excerpt_text = post['excerpt'];

			if ( 0 <= excerpt_text.search( '{read_more}' ) ) {
				$read_more = $( '<a>Read more</a>' );
				$read_more.addClass( 'read-more' );
				$read_more.attr( 'href', post['permalink'] );

				excerpt_text = excerpt_text.replace( '{read_more}', '' );

				text_node = $excerpt.html( decode_entities( excerpt_text ) );

				$excerpt.append( $( '<br />' ) );
				$excerpt.append( $read_more );
			} else {
				text_node = $excerpt.html( decode_entities( excerpt_text ) );
			}

			$new_wrapper.append( $excerpt );
		}

		$results_wrapper.append( $new_wrapper );
	}

	/**
	 * Decodes html entities within a string.
	 *
	 * This is useful if you need to pass an html escaped string into jQuery.fn.text().
	 *
	 * @param string text The text to decode html entities in.
	 *
	 * @returns The provided text with html entities decoded.
	 */
	function decode_entities( text ) {
		var y = document.createElement( 'textarea' );

		y.innerHTML = text;

		return y.value;
	}

	/**
	 * Ready up some closure variables and make the callback function global.
	 */
	$( document ).ready( function () {
		var searchForm = document.getElementById( 'search-page-form' );
		$results_wrapper = $( '.js-search-results' );
		$result_template = $( '.js-search-result-template' );

		window.jdrf_display_search_results = jdrf_display_search_results;

		if ( searchForm ) {
			jQuery( searchForm ).on( 'click', '.form-control-close', function() {
				document.getElementById( 'search-page-form-input' ).value = '';
			});
		}
	} );

} )( jQuery );
